import { useLocation, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OrderConfirmationPage = () => {
  const location = useLocation();
  const { orderId, email } = location.state || {};

  return (
    <div
      data-testid="order-confirmation-page"
      className="pt-20 min-h-screen bg-void flex items-center justify-center px-6"
    >
      <div className="max-w-lg w-full text-center">
        <div className="w-20 h-20 bg-toxic-green/20 rounded-full flex items-center justify-center mx-auto mb-8">
          <CheckCircle className="w-10 h-10 text-toxic-green" />
        </div>

        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4">
          Order Confirmed!
        </h1>

        <p className="text-neutral-400 mb-8">
          Thank you for your purchase. Your handcrafted skull art is being prepared with care.
        </p>

        {orderId && (
          <div className="bg-void-paper border border-white/10 p-6 mb-8">
            <p className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-2">
              Order Reference
            </p>
            <p data-testid="order-id" className="text-white font-mono">
              {orderId}
            </p>
          </div>
        )}

        {email && (
          <p className="text-sm text-neutral-400 mb-8">
            A confirmation email has been sent to{' '}
            <span className="text-white">{email}</span>
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/shop"
            data-testid="continue-shopping-btn"
            className="bg-electric-violet text-white px-8 py-4 font-mono uppercase tracking-widest text-sm hover:bg-electric-violet-hover transition-colors"
          >
            Continue Shopping
          </Link>
          <Link
            to="/"
            data-testid="back-to-home-btn"
            className="border border-white/20 text-white px-8 py-4 font-mono uppercase tracking-widest text-sm hover:bg-white hover:text-black transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
